<template>
    <div class="private-and-policy">
        <div class="private-and-policy-wrap">
            <div class="container">
                <div class="title-block">
                    <h1>隱私權政策</h1>
                    <span class="update-date">更新於 2021 - 02 - 18</span>
                    <div class="description">
                        親愛的企業使用者您好，為了讓您能夠安心的使用本系統的各項服務與資訊，以下說明本系統之隱私權保護政策，為保障您的權益，請您詳細閱讀、理解並同意下列「隱私權政策」全部內容。
                    </div>
                </div>
                <div class="content-block">
                    <h2>隱私權政策聲明</h2>
                    <ul class="list">
                        <li>
                            當企業會員於本系統註冊或進入服務後，您將被視為已同意「隱私權政策」的所有條款和條件。意即您同意並接受本隱私權聲明政策，本系統將以相關條款和條件收集、使用和以其他形式運用您的個人資料；如您決定不向本系統提供您的個人資料，本系統將無法向您提供任何服務。
                        </li>
                        <li>隱私權政策經過修訂、更改或更新而生效之後，如您未停止、或您繼續進入或使用服務的行為，也將被視為已接受本隱私權政策及其修訂、更改或更新。如對於本隱私權政策相關事項有任何疑問，歡迎您與本公司聯絡。</li>
                        <li>員工帳號經自然人員工認證並正式註冊生效後，除性質上不相容外，與企業帳號等同視之，受相同保障與限制。</li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>隱私權政策適用範圍</h2>
                    <ul class="list">
                        <li>
                            本隱私權聲明及其所包含之告知事項，僅適用於本公司所有及營運的本系統。本隱私權政策不適用於本系統以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。故在此聲明；本公司及本系統對於其他網站或線上資源的隱私權政策與隱私設定，不負擔任何責任。
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>個人資料蒐集、處理及利用方式</h2>
                    <ul class="list">
                        <li>
                            1. 當企業會員註冊或進入本服務時，本系統會蒐集企業會員的個人資料，並依據本隱私權政策，對於企業會員提供給本公司的任何資訊內容，採取最為適當的使用；可能蒐集的資訊種類如下，包括但不限於:
                            <ul>
                                <li>( 1 )	用戶填寫或提供之相關個人資訊(包括自然人、法人與團體之資訊):例如自然人姓名、企業商號團體名稱、電話號碼、電子郵件地址、自然人出生年月日、自然人身分證號碼、企業商號團體統一編號等。</li>
                                <li>( 2 )	本系統運作蒐集之資訊:當您透過網路進入或使用本系統，本系統會運作使用某些技術，蒐集您的電腦、手機、或其他通訊設備傳送給本系統的資訊，該資訊包含但不限於:(1)IP位置、設備資訊，例如位置、網路資訊。(2)用戶名稱及密碼。(3)您透過服務所作的任何要求或交易的詳細資訊。</li>
                            </ul>
                        </li>
                        <li>
                            2. 本系統蒐集個人資料可能之目的如下:
                            <ul>
                                <li>( 1 )	企業會員註冊程序，與您建立並保有負責任的商業關係。</li>
                                <li>( 2 )	企業會員進入或使用本系統所需之驗證程序。</li>
                                <li>( 3 )	提供特定服務所需(包括但不限於不動產服務、行銷、個人資料之合法交易業務、消費者、客戶管理與服務、資（通）訊服務、資（通）訊與資料庫管理、資通安全與管理、網路購物及其他電子商務服務、廣告或商業行為管理、徵信、調查、統計與研究分析、其他自然人基於正當性目的所進行個人資料之蒐集處理及利用、其他經營合於營業登記項目或組織章程所定之業務、其他諮詢與顧問服務等)。</li>
                                <li>( 4 )	確保本公司符合相關法令規範要求。</li>
                                <li>( 5 )	分析企業會員對本系統之使用情形，以提供系統維護、更新、升級、偏好或客製化開發所需。</li>
                            </ul>
                        </li>
                        <li>
                            3. 非經企業會員同意，本系統不會將個人資料用於上開目的以外之其他用途。僅於本聲明範圍內為運用，絕不會任意透露、出售、交換、或出租給其他第三人、單位及團體，並且嚴禁內部人員私自使用這些資料。
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>資訊保護措施與聲明</h2>
                    <ul class="list">
                        <li>
                            1. 企業會員所提供的個人資料，本公司將以合於產業標準之合理技術及程序，防止個人資料洩露或遭未經授權的存取，並在提供個人資料的過程中避免上述風險發生，提供管理及保護。
                        </li>
                        <li>
                            2. 本系統主機均設有相關的各項資訊安全設備及必要防護措施，加以保護本系統及您的個人資料，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。
                        </li>
                        <li>
                            3. 惟本公司與本系統無法保證您的個人資料，於任何情形下均不會被駭客或任何電腦專家的攻擊而存取、揭露、更改或銷毀。
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>個人資料來源者之權利</h2>
                    <ul class="list">
                        <li>
                            1. 就本系統所蒐集、處理和利用的企業會員所提供或取自企業會員的個人資料，您可以行使本隱私權政策所規定的權利，惟於特定情形下本系統可能無法繼續提供服務給您。
                        </li>
                        <li>
                            2. 您可以依據相關法律以及本隱私權政策行使或要求本公司為以下內容:
                            <ul>
                                <li>( 1 )	查詢或請求閱覽本系統所蒐集的個人資料。</li>
                                <li>( 2 )	補充或更正本系統蒐集的個人資料。</li>
                                <li>( 3 )	請求本系統停止繼續蒐集、處理與利用其已蒐集的個人資料。</li>
                                <li>( 4 )	請求刪除本系統蒐集的個人資料。</li>
                            </ul>
                        </li>
                        <li>
                            3. 惟本公司得因下列情事考量，就您所提出之上開所列舉的權利行使請求為是否同意或暫緩的決定:
                            <ul>
                                <li>( 1 )	有妨害國家安全、外交和軍事機密，整體經濟利益或者其他重大國家利益之虞</li>
                                <li>( 2 )	有妨害公務人員執行法定職務之虞。</li>
                                <li>( 3 )	有妨害本公司及本系統或第三方的重大利益者之虞。</li>
                                <li>( 4 )	因執行職務或履行法定義務所必要。</li>
                                <li>( 5 )	已取得您書面同意。</li>
                                <li>( 6 )	對於您個人資料的正確性存有爭議。</li>
                            </ul>
                        </li>
                        <li>
                            4. 除下列情形外，本公司絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關。
                            <ul>
                                <li>( 1 )	提供本服務所必要或已取得您書面同意。</li>
                                <li>( 2 )	法律明文規定。</li>
                                <li>( 3 )	與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。</li>
                                <li>( 4 )	當您使用本系統有違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</li>
                                <li>( 5 )	有利於您的權益者。</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>隱私權保護政策之修正</h2>
                    <ul class="list">
                        <li>
                            1. 企業會員同意本系統得為符合法規條例的變更、個人資訊之收集與使用政策、功能或技術異動，隨時對本隱私權聲明進行修正。
                        </li>
                        <li>
                            2. 本系統作出新的修正之際，如有改變蒐集或使用個人資訊的方式，變更事項將會發布於本系統或本隱私權政策或其他本公司頁面，不再另行通知個別企業會員，請您密切注意相關修正內容。
                        </li>
                        <li>
                            3. 本公司於本系統或本隱私權政策或其他本公司頁面為更新修正發布後，倘您仍繼續使用本系統，即表示您已閱讀、瞭解並同意接受本隱私權政策之修正，並受修改後的隱私權政策所約束。
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    mounted () {
        this.$analytics.logEvent("隱私權政策", {
            screen_name: "隱私權政策"
        });
    },
    components: {
        
    }
}

</script>

<style lang="scss" scoped>
    .private-and-policy{
        background-color: #f6f6f6;
        .private-and-policy-wrap{
            padding-top: 75px;
            padding-bottom: 120px;
            position: relative;
            .container {
                width: 911px;
                margin-left: auto;
                margin-right: auto;
                box-sizing: border-box;
            }
            .title-block{
                position: relative;
                margin-bottom: 40px;
                h1{
                    font-size: 36px;
                    margin-bottom: 12px;
                }
                h1:before{
                    content: '';
                    position: absolute;
                    display: block;
                    top: -26px;
                    height: 3px;
                    width: 60px;
                    border-radius: 4.5px;
                    background-color: #ff9275;
                }
                .update-date{
                    position: absolute;
                    color: #a8a5a4;
                    top: 10px;
                    right: 0px;
                }
                .description{
                    width: 660px;
                    font-weight: 300;
                    line-height: 1.71;
                }
            }
            .content-block{
                background-color: #ffffff;
                padding: 24px 28px;
                margin-bottom: 24px;
                border-radius: 8px;
                border: solid 1px #f0f0f0;
                h2{
                    font-size: 20px;
                    margin-bottom: 8px;
                }
                .description{
                    color: #a8a5a4;
                    line-height: 1.71;
                }
                .list:before{
                    content: '';
                    position: absolute;
                    display: block;
                    top: -23px;
                    height: 2px;
                    width: 24px;
                    border-radius: 4.5px;
                    background-color: #ff9275;
                }
                .list{
                    position: relative;
                    margin-top: 42px;
                    width: 660px;
                    li{
                        line-height: 1.71;
                        font-weight: 300;
                        margin-bottom: 16px;
                        > ul{
                            position: relative;
                            margin-top: 16px;
                            margin-left: 20px;
                        }
                    }
                    
                }
            }
        }
    }
    // @media screen and (max-width: 1280px){
    //     .private-and-policy {
    //         .private-and-policy-wrap{
    //             padding: 75px 196px 120px;
    //         }
    //     }
    // }
    @media screen and (max-width: 1100px) {
        .private-and-policy{
            background-color: #f6f6f6;
            .private-and-policy-wrap{
                padding-top: 100px;
                padding-bottom: 40px;
                .container {
                    width: 100%;
                    padding: 0px 20px;
                    margin: unset;
                }
                .title-block{
                    h1{
                        font-size: 28px;
                        margin-bottom: 16px;
                    }
                    .update-date{
                        position: relative;
                        display: block;
                        margin-bottom: 18px;
                        top: 0px;
                    }
                    .description{
                        width: 100%;
                    }
                }
                .content-block{
                    padding: 20px;
                    .list{
                        width: 100%;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/officailPage/policyTerm/bizPrivacyPolicy.vue